const GOOGLE_CLIENT_KEY = GOOGLE_CLIENT_KEY ?? "";
export const googleLoaderOptions = {
  apiKey: process.env.GOOGLE_CLIENT_KEY || GOOGLE_CLIENT_KEY || "",
  version: "weekly",
};
